<adapt-feature-guidance [configItem]="configItem">
    <p>Having a clear purpose and vision means everyone knows WHY the organisation exists and WHERE its going.
        Together they provide a stable platform for the organisation.</p>
</adapt-feature-guidance>

<adapt-feature-configuration [configItem]="configItem"></adapt-feature-configuration>
